/**
 * Mensagem amigável para falha ao excluir/cancelar envelope (ex.: 400 da API).
 */
export function getEnvelopeDeleteErrorMessage(error) {
  const detail = error?.response?.data?.detail;
  const raw =
    typeof detail === 'string'
      ? detail
      : Array.isArray(detail)
        ? detail.map((d) => d.msg || d.message || JSON.stringify(d)).join(', ')
        : '';
  if (typeof raw === 'string' && raw.toLowerCase().includes('batch endorsement')) {
    return 'Este envelope faz parte de um lote de endosso. Cancele o lote na lista Endossos (aba Lotes).';
  }
  return raw || 'Não foi possível cancelar. Tente novamente.';
}
